.container {
    flex: 1;
    display: flex;
    flex-direction: column;
    margin-left: 0px;
    margin-right: 0px;
}

.chatRoot {
    flex: 1;
    display: flex;
}

.chatContainer {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
}

.chatEmptyState {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    max-height: 1024px;
    padding-top: 60px;
}

.chatEmptyStateLogo {
    margin-top: 0;
    margin-bottom: 0;
}

.chatEmptyStateSubtitle {
    font-weight: 600;
    margin-top: 0;
    margin-bottom: 10px;
}

@media only screen and (max-height: 780px) {
    .chatEmptyState {
        padding-top: 0;
    }
}

.chatMessageStream {
    flex-grow: 1;
    max-height: 1024px;
    max-width: 1028px;
    width: 100%;
    overflow-y: auto;
    padding-left: 24px;
    padding-right: 24px;
    display: flex;
    flex-direction: column;
}

.chatMessageGpt {
    margin-bottom: 20px;
    max-width: 80%;
    display: flex;
    min-width: 0px;
    width: 100%;
}

.chatMessageGptMinWidth {
    max-width: 500px;
    margin-bottom: 20px;
}

.chatInput {
    position: sticky;
    bottom: 0;
    flex: 0 0 100px;
    padding-top: 12px;
    padding-bottom: 24px;
    padding-left: 24px;
    padding-right: 24px;
    width: 100%;
    max-width: 1028px;
}

.chatAnalysisPanel {
    flex: 1;
    overflow-y: auto;
    max-height: 89vh;
    margin-left: 20px;
    margin-right: 20px;
}

.chatSettingsSeparator {
    margin-top: 15px;
}

.loadingLogo {
    font-size: 28px;
}

.commandsContainer {
    margin-top: 15px;
    margin-bottom: 12px;
    display: flex;
    align-self: flex-end;
    flex-wrap: wrap;
}

.commandsSubcontainer {
  display: flex;
  align-items: center;
}

.commandButton {
    margin-right: 20px;
}

.answerLoadBottomLocation {
    position: relative;
    top: 40px;
}

.domainSelectionHeader {
  text-align: center;
}

/* footer */

.footerContainer {
  background-color: inherit;
  padding: 5px;
  text-align: center;
  margin: 0 auto;
  border-radius: 5px;
  box-shadow: 0 0 2px black;
  width: 100%;
  max-width: 65%;
  font-style: italic;
}

@media only screen and (max-width: 768px) {
  .footerContainer {
    max-width: 90%;
    font-size: 0.9rem;
    padding: 8px;
  }
}

